"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UserSearchInput',
  data: function data() {
    return {
      tableFromNew: this.value
    };
  },
  props: {
    value: {
      type: Object,
      default: {}
    }
  },
  watch: {
    tableFromNew: {
      handler: function handler(newVal) {
        this.$emit('input', newVal);
      },
      deep: true
    }
  },
  methods: {
    handleChangeType: function handleChangeType() {
      this.tableFromNew.content = '';
    },
    handleChangeContent: function handleChangeContent(event) {
      if (this.tableFromNew.searchType === 'phone' || this.tableFromNew.searchType === 'uid') this.tableFromNew.content = event.replace(/[^0-9]/g, '');
      if (this.tableFromNew.content > 99999999999) {
        this.tableFromNew.content = ''; // 设置最大值为100
      }
    },
    // 清空搜索框
    clearInput: function clearInput() {
      this.tableFromNew.content = '';
      this.tableFromNew.searchType = 'all';
    },
    // 失去焦点
    handleBlur: function handleBlur() {
      this.$emit('searchList');
    },
    // 清除搜索框内容
    handleClear: function handleClear() {
      this.$emit('searchList');
    }
  }
};